function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Hls from "@mediahub-bg/hls.js";
import hlsWorkerUrl from "@mediahub-bg/hls.js/dist/hls.worker.js";
import { deleteAuthToken, getAllEpgsForChannel, openModal, removeUserDetails, resetVideo, resetVideoToPlayAfterSubscription, setCurrentVideo, setProfileSettings, setVideoOptions, setVideoPlayerEpgs, setVideoToPlayAfterSubscription, toggleHeader, toggleVideoPlayerState } from "@common/actions";
import { ERROR_SUBCODE_STREAM_LIMIT, LANG_DEFAULT, LIMIT, RESOLUTION_AUTO, SUBTITLES_OFF } from "@common/constants";
import { deleteOrderObject, deleteSessionLockTime, deleteTokenObject, getDateAndTime, isCastAvailable, isMobile } from "@common/services/helpers";
import request from "@common/services/request";
import { SLIDER_FOR_PLAYER } from "@common/services/responsive";
import { ANIMATION_TIMEOUT, CHANGE_PREV_EPG, DOUBLE_CLICK_TIMEOUT, ENABLE_LIVE_SECONDS, ERROR_CODES_THAT_REQUIRE_LOGIN, ERROR_SUBCODE_TOO_MANY_USERS, HEADER_HEIGHT_WEB, KEY_ARROW_DOWN, KEY_ARROW_LEFT, KEY_ARROW_RIGHT, KEY_ARROW_UP, KEY_ENTER, KEY_ESCAPE, KEY_SPACE, KEY_TAB, LARGE_MOBILE_TYPE_PX, MOBILE_TYPE_PX, PLAYER_AUTOHIDE_TIMER, ROUTE_SIGN_IN, ROUTE_TOO_MANY_USERS, SECONDS_TO_REVERT, STATUS_CODE_BAD_REQUEST, SUBTITLE_OFF_ID, TIME_BEFORE_BUFFER, TIME_TO_RECOVER, TOOLTIP_SHOW_DELAY, VOD, VOLUME_MAX, VOLUME_MIN, VOLUME_STEP } from "@config/constants";
import ChannelLogo from "@common/components/ChannelLogo";
import ShowsSlider from "@common/components/shows-slider/ShowsSlider";
import { changeWebSetting, diffObjects, findDeviceSettingsItem, findDeviceSettingsItemIndex } from "@common/utils/helpers";
import { isEqual, isNil } from "lodash";
import ChannelInfo from "./ChannelInfo";
import ChromeCastButton from "./ChromecastButton";
import FullScreenButton from "./FullScreenButton";
import MenuButton from "./MenuButton";
import PlaybackButtons from "./PlaybackButtons";
import PlayerControls from "./PlayerControls";
import PlayerOptions from "./PlayerOptions";
import ProgressBar from "./ProgressBar";
import SettingsList from "./SettingsList";
// Components
import Video from "./Video";
var AIRPLAY_DISCONNECT_TIMEOUT = 2000;
var PlayerWrapper = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(PlayerWrapper, Component);
    var _super = _create_super(PlayerWrapper);
    function PlayerWrapper() {
        _class_call_check(this, PlayerWrapper);
        var _this;
        _this = _super.call(this);
        _define_property(_assert_this_initialized(_this), "detectTabKey", function(e) {
            var key = e.which;
            if (key === KEY_TAB && document.activeElement !== document.body) {
                setTimeout(function() {
                    _this.setState({
                        focusedElement: document.activeElement
                    });
                }, 0);
            }
        });
        _define_property(_assert_this_initialized(_this), "openPlayer", function(e) {
            if (!_this.props.videoPlayer.isOpen && e.target === _this.videoPlayerWrapper) {
                _this.props.toggleVideoPlayerState({
                    isOpen: true,
                    isPlaying: true
                });
            }
        });
        _define_property(_assert_this_initialized(_this), "startCastSession", function() {
            var _this_props = _this.props, videoPlayer = _this_props.videoPlayer, liveChannels = _this_props.liveChannels;
            var castSession = cast.framework.CastContext.getInstance().getCurrentSession();
            var chromeCastPlayer = new cast.framework.RemotePlayer();
            var chromeCastControls = new cast.framework.RemotePlayerController(chromeCastPlayer);
            var channelId = videoPlayer.channelId;
            var currentEpg = videoPlayer.epgs.current;
            var channelLogoURL = liveChannels[channelId] && liveChannels[channelId].images.baseURL + liveChannels[channelId].images.png350LeftWhite;
            var mediaInfo = new chrome.cast.media.MediaInfo(videoPlayer.video.source, "video/mp4");
            mediaInfo.metadata = new chrome.cast.media.GenericMediaMetadata();
            mediaInfo.metadata.metadataType = 0;
            if (channelLogoURL) {
                mediaInfo.metadata.images = [
                    {
                        url: channelLogoURL
                    }
                ];
            }
            mediaInfo.metadata.sectionDuration = _this.props.videoPlayer.video.duration;
            mediaInfo.metadata.title = currentEpg.title;
            mediaInfo.metadata.subtitle = currentEpg.subtitle;
            var request = new chrome.cast.media.LoadRequest(mediaInfo);
            castSession.loadMedia(request);
            _this.setState({
                castSession: castSession,
                chromeCastPlayer: chromeCastPlayer,
                chromeCastControls: chromeCastControls
            });
        });
        var _this1 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "setEpgs", function() {
            var _ref = _async_to_generator(function(videoPlayer) {
                var currentEpgIndex, nextEpgIndex, pastEpgIndex, epgs, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            currentEpgIndex = videoPlayer.isVod ? videoPlayer.allEpgs && videoPlayer.allEpgs.findIndex(function(e) {
                                return e.id === videoPlayer.channelId;
                            }) : videoPlayer.allEpgs && videoPlayer.allEpgs.findIndex(function(item) {
                                return item.start === videoPlayer.video.start;
                            });
                            if (!(currentEpgIndex !== undefined && currentEpgIndex !== null && currentEpgIndex !== -1)) return [
                                3,
                                4
                            ];
                            nextEpgIndex = currentEpgIndex + 1;
                            pastEpgIndex = currentEpgIndex - 1;
                            epgs = {
                                all: videoPlayer.allEpgs,
                                current: videoPlayer.allEpgs[currentEpgIndex],
                                next: typeof videoPlayer.allEpgs[nextEpgIndex] !== "undefined" ? videoPlayer.allEpgs[nextEpgIndex] : null,
                                prev: typeof videoPlayer.allEpgs[pastEpgIndex] !== "undefined" ? videoPlayer.allEpgs[pastEpgIndex] : null,
                                initialOffset: currentEpgIndex + 1,
                                initialToIndex: currentEpgIndex
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this1.props.setVideoPlayerEpgs(epgs)
                            ];
                        case 2:
                            _state.sent();
                            if (_this1.state.castSession) {
                                _this1.startCastSession();
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(videoPlayer) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property(_assert_this_initialized(_this), "toggleEpgsList", function() {
            _this.setState(function(param) {
                var isOpenEpgsList = param.isOpenEpgsList;
                return {
                    isOpenEpgsList: !isOpenEpgsList
                };
            });
        });
        _define_property(_assert_this_initialized(_this), "toggleEpgsListFromKeyboard", function(e) {
            var key = e.which;
            if (key === KEY_ENTER || key === KEY_SPACE) {
                _this.toggleEpgsList(e, true);
                e.stopPropagation();
            }
        });
        _define_property(_assert_this_initialized(_this), "toggleSettingsList", function(isToggledFromKeyboard) {
            var options = {
                isSettingsListToggledFromKeyboard: isToggledFromKeyboard
            };
            if (!_this.state.isOpenShareList) {
                options.shouldFocusSettingsButton = true;
            }
            _this.setState(function(param) {
                var isOpenSettingsList = param.isOpenSettingsList;
                return _object_spread_props(_object_spread({}, options), {
                    isOpenSettingsList: !isOpenSettingsList
                });
            });
        });
        _define_property(_assert_this_initialized(_this), "toggleShareList", function(isToggledFromKeyboard) {
            var options = {
                isShareListToggledFromKeyboard: isToggledFromKeyboard
            };
            if (!_this.state.isOpenShareList) {
                options.shouldFocusShareButton = true;
            }
            _this.setShareTime();
            _this.setState(function(param) {
                var isOpenShareList = param.isOpenShareList;
                return _object_spread_props(_object_spread({}, options), {
                    isOpenShareList: !isOpenShareList
                });
            });
        });
        _define_property(_assert_this_initialized(_this), "setShareTime", function() {
            _this.props.setVideoOptions({
                shareTime: _this.getCurrentTime()
            });
        });
        _define_property(_assert_this_initialized(_this), "showControls", function() {
            clearTimeout(_this.controlsTimeout);
            if (_this.state.areControlsHidden) {
                !isMobile.any() && _this.props.toggleHeader(false);
                _this.setState({
                    areControlsHidden: false
                });
            }
        });
        _define_property(_assert_this_initialized(_this), "showControlsAddFlag", function() {
            _this.showControls();
            _this.isMouseDown = true;
        });
        _define_property(_assert_this_initialized(_this), "hideControlsWithTimeout", function() {
            var _this_props = _this.props, screenType = _this_props.screenType, _$toggleHeader = _this_props.toggleHeader, isMobileOnLandscape = _this_props.isMobileOnLandscape;
            clearTimeout(_this.controlsTimeout);
            if (!_this.state.isOpenShareList && !_this.state.isOpenSettingsList && !_this.isMouseDown && !_this.state.castSession) {
                _this.controlsTimeout = setTimeout(function() {
                    if (screenType.web || screenType.tablet && !isMobileOnLandscape) {
                        if (document.activeElement !== document.body) {
                            _this.setState({
                                focusedElement: document.activeElement
                            });
                        }
                        !isMobile.any() && _$toggleHeader(true);
                        if (_this.state.isOpenEpgsList) {
                            _this.toggleEpgsList();
                        }
                    }
                    _this.setState({
                        areControlsHidden: true
                    });
                }, PLAYER_AUTOHIDE_TIMER);
            }
        });
        _define_property(_assert_this_initialized(_this), "hideControlsWithTimeoutRemoveFlag", function() {
            var _this_props = _this.props, screenType = _this_props.screenType, _$toggleHeader = _this_props.toggleHeader, isMobileOnLandscape = _this_props.isMobileOnLandscape;
            clearTimeout(_this.controlsTimeout);
            _this.isMouseDown = false;
            if (!_this.state.isOpenShareList && !_this.state.isOpenSettingsList && !_this.state.castSession) {
                _this.controlsTimeout = setTimeout(function() {
                    if (screenType.web || screenType.tablet && !isMobileOnLandscape && !isMobile.any()) {
                        _$toggleHeader(true);
                    }
                    _this.setState({
                        areControlsHidden: true
                    });
                }, PLAYER_AUTOHIDE_TIMER);
            }
        });
        _define_property(_assert_this_initialized(_this), "toggleControls", function() {
            _this.showControls();
            _this.hideControlsWithTimeout();
        });
        _define_property(_assert_this_initialized(_this), "closeList", function() {
            if (_this.state.isOpenShareList) {
                _this.toggleShareList(_this.state.isShareListToggledFromKeyboard);
            }
            if (_this.state.isOpenSettingsList) {
                _this.toggleSettingsList(_this.state.isSettingsListToggledFromKeyboard);
            }
        });
        _define_property(_assert_this_initialized(_this), "hideControls", function() {
            var _this_props = _this.props, screenType = _this_props.screenType, _$toggleHeader = _this_props.toggleHeader, isMobileOnLandscape = _this_props.isMobileOnLandscape, videoPlayer = _this_props.videoPlayer;
            var event = window.event;
            var mousePosY = null;
            if (event) {
                mousePosY = event.clientY;
            }
            if (!_this.state.isOpenShareList && !_this.state.isOpenSettingsList && !_this.state.castSession && videoPlayer.isOpen) {
                if (mousePosY <= window.innerHeight - HEADER_HEIGHT_WEB || mousePosY >= window.innerHeight) {
                    clearTimeout(_this.controlsTimeout);
                    if (screenType.web || screenType.tablet && !isMobileOnLandscape && !isMobile.any()) {
                        _$toggleHeader(true);
                    }
                    _this.setState({
                        areControlsHidden: true
                    });
                }
            }
        });
        _define_property(_assert_this_initialized(_this), "controlVideoFromKeyboard", function(e) {
            var key = e.which;
            var volume = null;
            if (typeof _this.props.videoPlayer.video.volume !== "undefined") {
                volume = _this.props.videoPlayer.video.volume;
            } else {
                volume = VOLUME_MAX;
            }
            if (key === KEY_ENTER || key === KEY_SPACE) {
                _this.togglePlay();
            }
            if (key === KEY_ARROW_LEFT) {
                _this.backward(SECONDS_TO_REVERT, true);
            }
            if (key === KEY_ARROW_RIGHT) {
                _this.forward(SECONDS_TO_REVERT, true);
            }
            if (key === KEY_ARROW_UP && volume < VOLUME_MAX - VOLUME_STEP) {
                _this.setVolume(volume + VOLUME_STEP, true);
                _this.setState({
                    shouldShowVolumeUpIcon: true
                });
            }
            if (key === KEY_ARROW_DOWN) {
                _this.setState({
                    shouldShowVolumeDownIcon: true
                });
                volume > VOLUME_STEP ? _this.setVolume(volume - VOLUME_STEP, true) : _this.setVolume(VOLUME_MIN, false);
            }
            if (key === KEY_ESCAPE) {
                _this.closeList();
            }
        });
        _define_property(_assert_this_initialized(_this), "onAirPlayTargetChanged", function() {
            if (!_this.video) {
                return;
            }
            var wireless = Boolean(_this.video.webkitCurrentPlaybackTargetIsWireless);
            if (wireless) {
                clearTimeout(_this.airPlayDisconnectTimer);
                _this.airPlayDisconnectTimer = null;
                if (!_this.airPlayNativePlayback) {
                    _this.airPlayNativePlayback = true;
                    _this.loadNativeAirPlaySource(_this.props.videoPlayer.video, _this.getCurrentTime() || 0);
                }
                return;
            }
            if (_this.airPlayNativePlayback && _this.airPlayDisconnectTimer === null) {
                var restoreTime = _this.getCurrentTime() || 0;
                _this.airPlayDisconnectTimer = setTimeout(function() {
                    _this.airPlayNativePlayback = false;
                    _this.airPlayDisconnectTimer = null;
                    _this.video.removeAttribute("src");
                    _this.playOnLoadedMetadata(restoreTime);
                    _this.initPlayer(_this.props.videoPlayer.video);
                }, AIRPLAY_DISCONNECT_TIMEOUT);
            }
        });
        _define_property(_assert_this_initialized(_this), "loadNativeAirPlaySource", function(video, startTime) {
            if (!video || !video.source) {
                return;
            }
            if (_this.hls !== null) {
                _this.hls.destroy();
                _this.hls = null;
            }
            _this.playOnLoadedMetadata(startTime);
            _this.video.src = video.source;
            _this.video.disableRemotePlayback = false;
            _this.video.load();
        });
        _define_property(_assert_this_initialized(_this), "playOnLoadedMetadata", function(startTime) {
            _this.video.addEventListener("loadedmetadata", function() {
                var duration = _this.video.duration;
                _this.video.currentTime = Number.isFinite(duration) ? Math.min(startTime, duration) : startTime;
                var playPromise = _this.video.play();
                if (playPromise) {
                    playPromise.catch(function(error) {
                        return console.warn("Playback failed: ".concat(error.message));
                    });
                }
            }, {
                once: true
            });
        });
        _define_property(_assert_this_initialized(_this), "initPlayer", function(video) {
            _this.video.removeEventListener("canplay", _this.video.play);
            if (_this.airPlayNativePlayback) {
                _this.loadNativeAirPlaySource(video, video.startPosition > 0 ? video.startPosition : 0);
                _this.video.ontimeupdate = _this.timeUpdate;
                return;
            }
            if (Hls.isSupported()) {
                if (_this.hls !== null) {
                    _this.hls.destroy();
                }
                // create a new HLS object
                _this.hls = new Hls({
                    autoStartLoad: false,
                    enableWorker: true,
                    workerPath: hlsWorkerUrl,
                    capLevelOnFPSDrop: true,
                    startLevel: 0,
                    defaultDvbAudioLanguage: _this.getDefaultResource("audio"),
                    debug: true
                });
                // bind video element to this HLS object
                var canvasEl = document.getElementById("dvb-canvas");
                _this.hls.attachMedia(_this.video);
                _this.hls.attachDvbCanvas(canvasEl);
                // MEDIA_ATTACHED event is fired by hls object once MediaSource is ready
                _this.hls.on(Hls.Events.MEDIA_ATTACHED, function() {
                    // video and hls.js are now bound together!
                    _this.loadVideo(video);
                });
            } else if (_this.video.canPlayType("application/vnd.apple.mpegurl")) {
                if (!_this.state.initsFirstTime) {
                    _this.setState({
                        initsFirstTime: true
                    });
                    _this.toggleMute(true);
                }
                _this.video.src = video.source;
                _this.video.addEventListener("canplay", _this.playVideoOnNative);
            }
            _this.video.ontimeupdate = _this.timeUpdate;
        });
        _define_property(_assert_this_initialized(_this), "loadVideo", function(video) {
            if (_this.sendEventTimeout) {
                clearTimeout(_this.sendEventTimeout);
            }
            _this.sendEventLock = true;
            // Start sending events after watching for 1 minute
            _this.sendEventTimeout = setTimeout(function() {
                _this.sendEventLock = false;
            }, 60 * 1000);
            if (Object.keys(video).length === 0) {
                return;
            }
            _this.hls.loadSource(video.source);
            if (_this.isIos() && window.ManagedMediaSource) {
                var airPlaySource = document.createElement("source");
                airPlaySource.type = "application/x-mpegURL";
                airPlaySource.src = video.source;
                _this.video.appendChild(airPlaySource);
                _this.video.disableRemotePlayback = false;
                _this.video.setAttribute("x-webkit-airplay", "allow");
            }
            _this.props.setVideoOptions({
                duration: video.stop - video.start,
                ended: false,
                paused: false,
                autoPaused: false,
                waiting: false,
                hasStarted: false,
                isLiveEpg: video.now,
                isFullscreen: _this.props.videoPlayer.video.isFullscreen || false,
                muted: false
            });
            // data: { levels : [available quality levels], audioTracks : [ available audio tracks], url : manifestURL, stats : { trequest, tfirst, tload, mtime}}
            _this.hls.on(Hls.Events.MANIFEST_PARSED, function(event, data) {
                _this.hls.startLoad(video.startPosition);
                var levels = data.levels.map(function(level, index) {
                    return {
                        resolution: level.attrs.RESOLUTION,
                        name: level.name,
                        height: level.height,
                        value: index
                    };
                });
                _this.props.setVideoOptions({
                    levels: levels,
                    autoLevel: true
                });
                _this.handleInitialVideoLevel(levels);
            });
            // Remove loading when new buffer is received after fatal error recover
            _this.hls.on(Hls.Events.BUFFER_APPENDING, function(event, data) {
                if (_this.state.videoHasFatalError) {
                    _this.setState({
                        videoHasFatalError: false
                    });
                    _this.recoverSwapAudioCodecDate = null;
                    _this.recoverDecodingErrorDate = null;
                }
                // TODO Remove toast message when recover form error
                if (_this.mediaErrorHandlerTimeout) {
                    clearTimeout(_this.mediaErrorHandlerTimeout);
                    _this.mediaErrorHandlerTimeout = undefined;
                }
            });
            // data: { level : id of new level }
            _this.hls.on(Hls.Events.LEVEL_SWITCHED, function(event, data) {
                _this.props.setVideoOptions({
                    currentLevel: data.level
                });
            });
            // data: { id : audio track id }
            _this.hls.on(Hls.Events.DVB_AUDIO_TRACK_SWITCHED, function(event, data) {
                _this.props.setVideoOptions({
                    currentAudioTrack: data.id
                });
            });
            _this.hls.on(Hls.Events.DVB_AUDIO_TRACKS_UPDATED, function(event, data) {
                _this.props.setVideoOptions({
                    audioTracks: data.audioTracks.length > 0 ? data.audioTracks : [],
                    currentAudioTrack: _this.hls.dvbAudioTrack
                });
            });
            //  data: { url : subtitle track URL, id : subtitle track id }
            _this.hls.on(Hls.Events.SUBTITLE_TRACK_SWITCH, function(event, data) {
                _this.props.setVideoOptions({
                    currentSubtitleTrack: data.id
                });
            });
            // data: { subtitleTracks : subtitleTracks }
            _this.hls.on(Hls.Events.DVB_SUBTITLE_TRACKS_UPDATED, function(event, data) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Enable all tracks
                    for(var _iterator = _this.video.textTracks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var track = _step.value;
                        if (track.mode === "disabled") track.mode = "hidden";
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                _this.props.setVideoOptions({
                    subtitleTracks: data.subtitleTracks || [],
                    currentSubtitleTrack: _this.hls.subtitleTrack || SUBTITLE_OFF_ID
                });
            });
            // TODO decide if this warnings stay
            _this.hls.on(Hls.Events.ERROR, function(event, data) {
                switch(data.details){
                    case Hls.ErrorDetails.MANIFEST_LOAD_ERROR:
                        break;
                    case Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
                        console.warn("Timeout while loading manifest");
                        break;
                    case Hls.ErrorDetails.MANIFEST_PARSING_ERROR:
                        console.warn("Error while parsing manifest:" + data.reason);
                        break;
                    case Hls.ErrorDetails.LEVEL_LOAD_ERROR:
                        console.warn("Error while loading level playlist");
                        break;
                    case Hls.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                        console.warn("Timeout while loading level playlist");
                        break;
                    case Hls.ErrorDetails.LEVEL_SWITCH_ERROR:
                        console.warn("Error while trying to switch to level " + data.level);
                        break;
                    case Hls.ErrorDetails.FRAG_LOAD_ERROR:
                        console.warn("Error while loading fragment " + data.frag.url);
                        break;
                    case Hls.ErrorDetails.FRAG_LOAD_TIMEOUT:
                        console.warn("Timeout while loading fragment " + data.frag.url);
                        break;
                    case Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
                        console.warn("Fragment-loop loading error");
                        break;
                    case Hls.ErrorDetails.FRAG_DECRYPT_ERROR:
                        console.warn("Decrypting error:" + data.reason);
                        break;
                    case Hls.ErrorDetails.FRAG_PARSING_ERROR:
                        console.warn("Parsing error:" + data.reason);
                        break;
                    case Hls.ErrorDetails.KEY_LOAD_ERROR:
                        console.warn("Error while loading key " + data.frag.decryptdata.uri);
                        break;
                    case Hls.ErrorDetails.KEY_LOAD_TIMEOUT:
                        console.warn("Timeout while loading key " + data.frag.decryptdata.uri);
                        break;
                    case Hls.ErrorDetails.BUFFER_APPEND_ERROR:
                        console.warn("Buffer append error");
                        break;
                    case Hls.ErrorDetails.BUFFER_ADD_CODEC_ERROR:
                        console.warn("Buffer add codec error for " + data.mimeType + ":" + data.err.message);
                        break;
                    case Hls.ErrorDetails.BUFFER_APPENDING_ERROR:
                        console.warn("Buffer appending error, reloading...");
                        // This error is not fatal but video stop when this error occurs
                        // So reload the playlist when this error happens
                        _this.handleReloadOfMedia();
                        break;
                    case Hls.ErrorDetails.BUFFER_STALLED_ERROR:
                        console.warn("Buffer stalled error");
                        _this.mediaErrorHandlerTimeout = setTimeout(function() {
                            _this.handleReloadOfMedia();
                        }, 5000);
                        break;
                    default:
                        break;
                }
                if (data.fatal) {
                    switch(data.type){
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            console.warn("Fatal media error encountered, trying to recover");
                            _this.setState({
                                videoHasFatalError: true
                            });
                            var now = performance.now();
                            if (!_this.recoverDecodingErrorDate || now - _this.recoverDecodingErrorDate > TIME_TO_RECOVER) {
                                _this.recoverDecodingErrorDate = performance.now();
                                console.warn("Trying to recover media error.");
                                // TODO add message Trying to recover media error.
                                _this.hls.recoverMediaError();
                            } else {
                                if (!_this.recoverSwapAudioCodecDate || now - _this.recoverSwapAudioCodecDate > TIME_TO_RECOVER) {
                                    _this.recoverSwapAudioCodecDate = performance.now();
                                    console.warn("Trying to swap audio codecs and recover media error.");
                                    // TODO add message Trying to swap audio codecs and recover media error.
                                    _this.hls.swapAudioCodec();
                                    _this.hls.recoverMediaError();
                                } else {
                                    console.warn("Cannot recover. Last media error recovery failed.");
                                }
                            }
                            break;
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            _this.handleHlsNetworkError(_object_spread({}, data));
                            break;
                        default:
                            // cannot recover
                            console.warn("An unrecoverable error occurred");
                            // TODO add message A network error occurred, try to recover
                            _this.hls.destroy();
                            break;
                    }
                } else {
                    switch(data.type){
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            _this.handleNonFatalNetworkError(_object_spread({}, data));
                            break;
                    }
                }
            });
        });
        _define_property(_assert_this_initialized(_this), "handleHlsNetworkError", function(data) {
            var _ref = data.networkDetails = {}, status = _ref.status, response = _ref.response;
            var errorCode;
            try {
                if (typeof response === "string" && response !== "") {
                    errorCode = (JSON.parse(response) || {}).subcode;
                }
            } catch (error) {
                console.error(error);
            }
            // Handling if it's a custom error:
            // SignOuts the user
            // and based on the `subcode` property of response
            // redirects to Login or to TooManyUsers page
            if (status === STATUS_CODE_BAD_REQUEST && errorCode && (ERROR_CODES_THAT_REQUIRE_LOGIN.includes(errorCode) || errorCode === ERROR_SUBCODE_TOO_MANY_USERS)) {
                deleteTokenObject();
                deleteSessionLockTime();
                deleteOrderObject();
                _this.props.deleteAuthToken();
                _this.props.resetVideo();
                _this.props.removeUserDetails();
                if (ERROR_CODES_THAT_REQUIRE_LOGIN.includes(errorCode)) {
                    _this.props.history.push(ROUTE_SIGN_IN);
                } else if (errorCode === ERROR_SUBCODE_TOO_MANY_USERS) {
                    _this.props.history.push(ROUTE_TOO_MANY_USERS);
                }
            } else {
                // If it is not a custom error
                // shows the loader and
                // tries to recover network error
                _this.setState({
                    videoHasFatalError: true
                });
                console.warn("A network error occurred, try to recover");
                // TODO add message A network error occurred, try to recover
                _this.hls.startLoad();
            }
        });
        _define_property(_assert_this_initialized(_this), "handleNonFatalNetworkError", function(data) {
            var _data_networkDetails = data.networkDetails, status = _data_networkDetails.status, response = _data_networkDetails.response;
            var errorCode;
            try {
                if (typeof response === "string" && response !== "") {
                    errorCode = (JSON.parse(response) || {}).subcode;
                }
            } catch (error) {
                console.error(error);
            }
            if (status === STATUS_CODE_BAD_REQUEST && errorCode) {
                switch(errorCode){
                    case ERROR_SUBCODE_STREAM_LIMIT:
                        {
                            _this.pause();
                            _this.props.videoPlayer.video.isFullscreen && _this.toggleFullscreen();
                            var onStop = function() {
                                _this.props.resetVideo();
                            };
                            var onContinue = function() {
                                var video = _object_spread_props(_object_spread({}, _this.props.videoPlayer.video), {
                                    startPosition: _this.getCurrentTime()
                                });
                                _this.initPlayer(video);
                            };
                            _this.props.openModal(LIMIT, {
                                onStop: onStop,
                                onContinue: onContinue
                            });
                        }
                        break;
                }
            }
        });
        _define_property(_assert_this_initialized(_this), "getResourceConfiguration", function(resourceKey) {
            try {
                var _this_props = _this.props, liveChannels = _this_props.liveChannels, profileSettings = _this_props.profileSettings, videoPlayer = _this_props.videoPlayer;
                var channelId = videoPlayer.channelId;
                var DeviceSettingsItemList = profileSettings.web_settings.DeviceSettingsItemList;
                var defaultResource = liveChannels[channelId][resourceKey];
                var individualResource = findDeviceSettingsItem(DeviceSettingsItemList, channelId).channelSettings[resourceKey];
                var globalResource = profileSettings.web_settings[resourceKey];
                return {
                    globalResource: globalResource,
                    individualResource: individualResource,
                    defaultResource: defaultResource
                };
            } catch (error) {
                return {
                    globalResource: "und",
                    individualResource: "und",
                    defaultResource: "und"
                };
            }
        });
        _define_property(_assert_this_initialized(_this), "handleReloadOfMedia", function() {
            if (_this.hls) {
                _this.setState({
                    videoHasFatalError: true
                });
                var timeBeforeReload = _this.getCurrentTime();
                _this.hls.recoverMediaError();
                var video = _object_spread_props(_object_spread({}, _this.props.videoPlayer.video), {
                    startPosition: timeBeforeReload
                });
                _this.initPlayer(video);
            }
        });
        _define_property(_assert_this_initialized(_this), "getDefaultResource", function(resourceKey) {
            var _this_getResourceConfiguration = _this.getResourceConfiguration(resourceKey), globalResource = _this_getResourceConfiguration.globalResource, individualResource = _this_getResourceConfiguration.individualResource, defaultResource = _this_getResourceConfiguration.defaultResource;
            // "und"/null mean "use default": fall through to the channel default track.
            // "zxx" (subtitles off) is a real value and is kept.
            var pick = function(v) {
                return v == null || v === LANG_DEFAULT ? undefined : v;
            };
            return pick(individualResource) || pick(globalResource) || defaultResource || LANG_DEFAULT;
        });
        _define_property(_assert_this_initialized(_this), "switchToDefaultResource", function() {
            var resourceList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], resourceKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", fieldToUpdate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            try {
                if (!resourceList.length || isNil(_this.hls[fieldToUpdate])) {
                    return;
                }
                var _this_getResourceConfiguration = _this.getResourceConfiguration(resourceKey), globalResource = _this_getResourceConfiguration.globalResource, individualResource = _this_getResourceConfiguration.individualResource, defaultResource = _this_getResourceConfiguration.defaultResource;
                var newResource = _this.getDefaultResource(resourceKey);
                var newResourceIndex = newResource === -1 || newResource === SUBTITLES_OFF ? -1 : resourceList.findLastIndex(function(param) {
                    var resourceName = param.name;
                    return resourceName === individualResource || resourceName === globalResource || resourceName === defaultResource;
                });
                var resourceId = newResourceIndex === -1 ? -1 : resourceList[newResourceIndex].id;
                if (_this.hls[fieldToUpdate] !== resourceId) {
                    _this.hls[fieldToUpdate] = resourceId;
                }
            } catch (error) {
                console.error(error);
                _this.hls[fieldToUpdate] = resourceList[0].id;
            }
        });
        _define_property(_assert_this_initialized(_this), "handleInitialVideoLevel", function() {
            var levels = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            var _this_props = _this.props, profileSettings = _this_props.profileSettings, videoPlayer = _this_props.videoPlayer;
            if (!levels || !_this.hls) {
                return;
            }
            try {
                var channelItem = findDeviceSettingsItem(profileSettings.web_settings.DeviceSettingsItemList, videoPlayer.channelId);
                var individualSettingResolution = channelItem && channelItem.channelSettings.resolution;
                var globalSettingResolution = profileSettings.web_settings.resolution;
                var resolution = individualSettingResolution || globalSettingResolution || RESOLUTION_AUTO;
                if (resolution === RESOLUTION_AUTO) {
                    _this.changeNextQuality(-1);
                    return;
                }
                // "1920x1080" -> 1080; legacy bare height -> itself
                var resolutionHeight = Number(String(resolution).split("x").pop());
                var levelHeights = levels.map(function(level) {
                    return level.height;
                });
                var level = levelHeights.findLastIndex(function(height) {
                    return resolutionHeight >= height;
                });
                _this.changeNextQuality(level);
            } catch (error) {
                console.error(error);
                _this.changeNextQuality(-1);
            }
        });
        _define_property(_assert_this_initialized(_this), "toggleCromecastPlay", function(shouldPlay) {
            if (isCastAvailable()) {
                var castSession = cast.framework.CastContext.getInstance().getCurrentSession();
                if (castSession) {
                    var sessionId = castSession.getSessionId();
                    var mediaSession = castSession.getMediaSession();
                    var media = new chrome.cast.media.Media(sessionId, mediaSession.mediaSessionId);
                    if (shouldPlay) {
                        var playRequest = new chrome.cast.media.PlayRequest();
                        media.play(playRequest);
                    } else {
                        var pauseRequest = new chrome.cast.media.PauseRequest();
                        media.pause(pauseRequest);
                    }
                }
            }
        });
        _define_property(_assert_this_initialized(_this), "playVideoOnNative", function() {
            _this.video.removeEventListener("canplay", _this.playVideoOnNative);
            if (_this.props.videoPlayer.video.startPosition > 0) {
                _this.video.currentTime = _this.props.videoPlayer.video.startPosition;
            }
            _this.video.play();
        });
        _define_property(_assert_this_initialized(_this), "play", function() {
            _this.video.play();
            _this.props.setVideoOptions({
                paused: false
            });
            _this.toggleCromecastPlay(true);
        });
        _define_property(_assert_this_initialized(_this), "pause", function() {
            _this.video.pause();
            _this.props.setVideoOptions({
                paused: true
            });
            _this.toggleCromecastPlay(false);
        });
        _define_property(_assert_this_initialized(_this), "togglePlay", function() {
            _this.clickCount++;
            if (_this.clickCount === 1) {
                setTimeout(function() {
                    _this.clickCount = 0;
                }, DOUBLE_CLICK_TIMEOUT);
                if (_this.props.videoPlayer.video.paused) {
                    _this.play();
                    _this.toggleControls();
                } else {
                    _this.pause();
                    _this.showControls();
                }
            } else {
                _this.toggleFullscreen();
                _this.props.videoPlayer.video.paused ? _this.play() : _this.pause();
            }
        });
        _define_property(_assert_this_initialized(_this), "chromecastSeekRequest", function(currentTime) {
            if (isCastAvailable()) {
                var castSession = cast.framework.CastContext.getInstance().getCurrentSession();
                if (castSession) {
                    var seekRequest = new chrome.cast.media.SeekRequest();
                    var sessionId = castSession.getSessionId();
                    var mediaSession = castSession.getMediaSession();
                    var media = new chrome.cast.media.Media(sessionId, mediaSession.mediaSessionId);
                    seekRequest.currentTime = currentTime;
                    media.seek(seekRequest);
                }
            }
        });
        _define_property(_assert_this_initialized(_this), "forward", function(seconds, isTriggeredFromKeyboard) {
            var secondsToForward = _this.video.currentTime + seconds;
            if (_this.props.videoPlayer.video.isLiveEpg && _this.video.duration - TIME_BEFORE_BUFFER - _this.video.currentTime < SECONDS_TO_REVERT) {
                secondsToForward = _this.video.currentTime + _this.video.duration - TIME_BEFORE_BUFFER - _this.video.currentTime;
            }
            if (isTriggeredFromKeyboard) {
                _this.setState({
                    isForwardClicked: true
                });
                setTimeout(function() {
                    _this.setState({
                        isForwardClicked: false
                    });
                }, ANIMATION_TIMEOUT);
            }
            _this.toggleControls();
            _this.setCurrentTime(secondsToForward);
            _this.chromecastSeekRequest(secondsToForward);
        });
        _define_property(_assert_this_initialized(_this), "backward", function(seconds, isTriggeredFromKeyboard) {
            if (isTriggeredFromKeyboard) {
                _this.setState({
                    isBackwardClicked: true
                });
                setTimeout(function() {
                    _this.setState({
                        isBackwardClicked: false
                    });
                }, ANIMATION_TIMEOUT);
            }
            _this.toggleControls();
            _this.setCurrentTime(_this.video.currentTime - seconds);
            _this.chromecastSeekRequest(_this.video.currentTime);
        });
        _define_property(_assert_this_initialized(_this), "getCurrentTime", function() {
            if (_this.video) {
                return _this.video.currentTime;
            }
        });
        _define_property(_assert_this_initialized(_this), "setCurrentTime", function(value) {
            _this.video.currentTime = value;
            if (_this.props.videoPlayer.video.isLiveEpg) {
                _this.progress();
            }
        });
        _define_property(_assert_this_initialized(_this), "setVideoToLive", function() {
            _this.setCurrentTime(_this.getDuration() - TIME_BEFORE_BUFFER);
            _this.chromecastSeekRequest(_this.getDuration() - TIME_BEFORE_BUFFER);
        });
        /**
   * Get video duration
   * if video is VOD duration is equal to stop - start
   * if video is live duration is equal to loaded live time
   * @returns {*}
   */ _define_property(_assert_this_initialized(_this), "getDuration", function() {
            return _this.video.duration;
        });
        _define_property(_assert_this_initialized(_this), "ended", function() {
            var next = _this.props.videoPlayer.epgs.next;
            next.startPosition = 0;
            _this.changeVideo(next.chanId, next);
        });
        _define_property(_assert_this_initialized(_this), "timeUpdate", function() {
            var _this_props_videoPlayer = _this.props.videoPlayer, video = _this_props_videoPlayer.video, epgs = _this_props_videoPlayer.epgs;
            var currentTime = _this.getCurrentTime();
            var videoOptions = {};
            if (currentTime && !_this.sendEventLock) {
                // cast to int, event emits multiple times per second
                // we're interested in sending the request every 4 seconds
                var currentTimeSeconds = currentTime | 0;
                if (_this.prevEventTime !== currentTimeSeconds && currentTimeSeconds % 4 === 0) {
                    var payload = {
                        eventId: epgs.current.eventid,
                        contentId: epgs.current.contentId,
                        offset: currentTimeSeconds
                    };
                    // if we send both request will fail
                    // eventId is preferred, but not present in vod epgs
                    if (payload.eventId && payload.eventId !== "") {
                        delete payload["contentId"];
                    }
                    request({
                        method: "post",
                        url: "/epgs/event/record",
                        data: payload
                    });
                    _this.prevEventTime = currentTimeSeconds;
                }
            }
            // Disable/Enable previous button
            if (currentTime < CHANGE_PREV_EPG) {
                if (epgs && epgs.prev && video.disablePrevButton) {
                    videoOptions.disablePrevButton = false;
                } else if (epgs && !epgs.prev && !video.disablePrevButton) {
                    videoOptions.disablePrevButton = true;
                }
            } else if (currentTime >= CHANGE_PREV_EPG && video.disablePrevButton) {
                videoOptions.disablePrevButton = false;
            }
            // Disable/Enable backward button
            if (currentTime < SECONDS_TO_REVERT) {
                if (epgs && epgs.prev && video.disableBackwardButton) {
                    videoOptions.disableBackwardButton = false;
                } else if (epgs && !epgs.prev && !video.disableBackwardButton) {
                    videoOptions.disableBackwardButton = true;
                }
            } else if (currentTime >= SECONDS_TO_REVERT && video.disableBackwardButton) {
                videoOptions.disableBackwardButton = false;
            }
            // Disable/Enable next button
            if (epgs && epgs.next && video.disableNextButton) {
                videoOptions.disableNextButton = false;
            } else if (epgs && !epgs.next && !video.disableNextButton) {
                videoOptions.disableNextButton = true;
            }
            // Handle hasStarted
            if (!video.hasStarted) {
                videoOptions.hasStarted = true;
            }
            // Handle missing duration
            if (!video.duration) {
                var _this_video;
                videoOptions.duration = ((_this_video = _this.video) === null || _this_video === void 0 ? void 0 : _this_video.duration) || 0;
            }
            if (Object.keys(videoOptions).length !== 0) {
                _this.props.setVideoOptions(videoOptions);
            }
            if (video.now && currentTime >= video.stop - video.start) {
                _this.ended();
            }
            if (!_this.state.areControlsHidden) {
                _this.setState(function() {
                    return {
                        currentTime: currentTime
                    };
                });
            }
        });
        _define_property(_assert_this_initialized(_this), "progress", function() {
            var currentTime = _this.getCurrentTime();
            var liveProgress = _this.getDuration();
            var video = _this.props.videoPlayer.video;
            var videoOptions = {};
            if (!video.isLiveEpg && video.disableForwardButton) {
                videoOptions.disableForwardButton = false;
            }
            // Disable/Enable live button
            if (video.isLiveEpg) {
                _this.setState({
                    liveProgress: liveProgress
                });
                if (liveProgress - currentTime < ENABLE_LIVE_SECONDS && !video.disableLiveButton) {
                    videoOptions.disableLiveButton = true;
                } else if (liveProgress - currentTime >= ENABLE_LIVE_SECONDS && video.disableLiveButton) {
                    videoOptions.disableLiveButton = false;
                }
                // Disable/Enable forward button
                if (liveProgress - currentTime < ENABLE_LIVE_SECONDS && !video.disableForwardButton) {
                    videoOptions.disableForwardButton = true;
                } else if (liveProgress - currentTime >= ENABLE_LIVE_SECONDS && video.disableForwardButton) {
                    videoOptions.disableForwardButton = false;
                }
            }
            if (video.now && video.start + liveProgress > video.stop) {
                videoOptions.isLiveEpg = false;
            }
            if (Object.keys(videoOptions).length !== 0) {
                _this.props.setVideoOptions(videoOptions);
            }
        });
        _define_property(_assert_this_initialized(_this), "getVolume", function() {
            return _this.video.volume;
        });
        _define_property(_assert_this_initialized(_this), "setVolume", function(value, isSoundChangedFromKeyboard) {
            _this.video.volume = value;
            _this.props.setVideoOptions({
                volume: value
            });
            if (value === VOLUME_MIN) {
                _this.setState({
                    isSoundToggledFromKeyboard: isSoundChangedFromKeyboard,
                    isVolumeChangedFromKeyboard: false
                });
            } else {
                _this.toggleMute(false);
                _this.setState({
                    isVolumeChangedFromKeyboard: isSoundChangedFromKeyboard
                });
                _this.toggleControls();
            }
        });
        _define_property(_assert_this_initialized(_this), "toggleMute", function(isMuted, isToggledFromUnmuteButton) {
            _this.video.muted = isMuted;
            var lastPositiveVolume = null;
            if (isMuted) {
                lastPositiveVolume = _this.props.videoPlayer.video.volume || VOLUME_MAX;
                _this.props.setVideoOptions({
                    lastPositiveVolume: lastPositiveVolume
                });
            }
            if (isToggledFromUnmuteButton) {
                _this.setVolume(_this.props.videoPlayer.video.lastPositiveVolume || VOLUME_MAX);
            }
            _this.props.setVideoOptions({
                muted: isMuted
            });
        });
        _define_property(_assert_this_initialized(_this), "isIos", function() {
            var ua = navigator.userAgent;
            return /iP(hone|od|ad)/.test(ua) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
        });
        _define_property(_assert_this_initialized(_this), "toggleFullscreen", function() {
            _this.video.focus();
            if (_this.props.videoPlayer.video.isFullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (_this.isIos()) {
                    if (_this.video.webkitEnterFullscreen) {
                        _this.video.webkitEnterFullscreen();
                    }
                } else if (_this.videoPlayerWrapper.requestFullscreen) {
                    _this.videoPlayerWrapper.requestFullscreen();
                } else if (_this.videoPlayerWrapper.mozRequestFullScreen) {
                    _this.videoPlayerWrapper.mozRequestFullScreen();
                } else if (_this.videoPlayerWrapper.webkitRequestFullscreen) {
                    _this.videoPlayerWrapper.webkitRequestFullscreen();
                } else if (_this.videoPlayerWrapper.msRequestFullscreen) {
                    _this.videoPlayerWrapper.msRequestFullscreen();
                }
                if (!_this.props.videoPlayer.isOpen) {
                    _this.props.toggleVideoPlayerState({
                        isOpen: true,
                        isPlaying: true
                    });
                }
            }
        });
        _define_property(_assert_this_initialized(_this), "setFullscreen", function() {
            if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
                _this.props.setVideoOptions({
                    isFullscreen: true
                });
            } else {
                _this.props.setVideoOptions({
                    isFullscreen: false
                });
            }
        });
        /**
   * Update the individual setting of quality for the current channel
   * @param {String} setting - the setting to update from DeviceSettingsItemList[index].channelSettings
   * @param {*} value - the value to set for the current channel settings
   */ _define_property(_assert_this_initialized(_this), "changeIndividualSetting", function(setting, value) {
            try {
                var _this_props = _this.props, profileSettings = _this_props.profileSettings, videoPlayer = _this_props.videoPlayer, _$setProfileSettings = _this_props.setProfileSettings;
                var channelId = videoPlayer.channelId;
                var DeviceSettingsItemList = profileSettings.web_settings.DeviceSettingsItemList;
                var index = findDeviceSettingsItemIndex(DeviceSettingsItemList, channelId);
                // Update value
                DeviceSettingsItemList[index].channelSettings[setting] = value;
                _$setProfileSettings(changeWebSetting(profileSettings, {
                    DeviceSettingsItemList: DeviceSettingsItemList
                }));
            //
            } catch (error) {
                console.error(error);
            }
        });
        _define_property(_assert_this_initialized(_this), "changeNextQuality", function(value) {
            _this.props.setVideoOptions({
                autoLevel: value < 0
            });
            _this.hls.nextLevel = value;
        });
        _define_property(_assert_this_initialized(_this), "changeQuality", function(value) {
            var autoLevel = value < 0;
            _this.props.setVideoOptions({
                autoLevel: autoLevel
            });
            var level = _this.hls.levels[value];
            // canonical resolution: "auto" or "WIDTHxHEIGHT"
            var resolution = autoLevel ? RESOLUTION_AUTO : level && level.width ? "".concat(level.width, "x").concat(level.height) : String(level ? level.height : "");
            _this.changeIndividualSetting("resolution", resolution);
            _this.hls.currentLevel = value;
            _this.setState({
                isOpenSettingsList: false
            });
        });
        // returns the track's language code, or null when "off"/not found
        _define_property(_assert_this_initialized(_this), "findLanguageName", function() {
            var resourceList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], value = arguments.length > 1 ? arguments[1] : void 0;
            var language = resourceList.find(function(e) {
                return e.id === value;
            });
            return value === -1 || isNil(language) ? null : language.name;
        });
        _define_property(_assert_this_initialized(_this), "changeAudioTrack", function(value) {
            _this.hls.dvbAudioTrack = value;
            var video = _this.props.videoPlayer.video;
            var _this_findLanguageName;
            _this.changeIndividualSetting("audio", (_this_findLanguageName = _this.findLanguageName(video.audioTracks, value)) !== null && _this_findLanguageName !== void 0 ? _this_findLanguageName : LANG_DEFAULT);
            _this.setState({
                isOpenSettingsList: false
            });
        });
        _define_property(_assert_this_initialized(_this), "changeSubtitleTrack", function(value) {
            _this.hls.subtitleTrack = value;
            var video = _this.props.videoPlayer.video;
            var _this_findLanguageName;
            _this.changeIndividualSetting("subtitles", (_this_findLanguageName = _this.findLanguageName(video.subtitleTracks, value)) !== null && _this_findLanguageName !== void 0 ? _this_findLanguageName : SUBTITLES_OFF);
            _this.setState({
                isOpenSettingsList: false
            });
        });
        _define_property(_assert_this_initialized(_this), "changeVideo", function(_channelId, video) {
            var isVod = _this.props.videoPlayer.isVod;
            var channelId = isVod ? video.id : _channelId;
            _this.props.setCurrentVideo({
                isOpen: true,
                isPlaying: true,
                channelId: channelId,
                video: {
                    start: video.start,
                    stop: video.stop,
                    startPosition: video.startPosition ? video.startPosition : 0,
                    isFullscreen: _this.props.videoPlayer.video.isFullscreen || false
                }
            }, isVod);
            _this.setState({
                isVideoChanged: true,
                shouldLoadNewVideo: true
            });
            setTimeout(function() {
                _this.setState({
                    isVideoChanged: false
                });
            }, ANIMATION_TIMEOUT);
        });
        _this.state = {
            isOpenEpgsList: false,
            isOpenSettingsList: false,
            isOpenShareList: false,
            areControlsHidden: false,
            currentTime: null,
            liveProgress: null,
            videoHasFatalError: false,
            isForwardClicked: false,
            isBackwardClicked: false,
            isVolumeChangedFromKeyboard: false,
            isSoundToggledFromKeyboard: false,
            isShareListToggledFromKeyboard: false,
            isSettingsListToggledFromKeyboard: false,
            shouldFocusShareButton: false,
            shouldFocusSettingsButton: false,
            focusedElement: document.activeElement,
            isVideoChanged: false,
            castSession: null,
            chromeCastControls: null,
            chromeCastPlayer: null,
            canSupportNativeHls: false,
            initsFirstTime: false,
            isVideoLoading: true,
            shouldLoadNewVideo: false
        };
        _this.clickCount = 0;
        _this.isMouseDown = false;
        _this.controlsTimeout = null;
        _this.videoPlayerWrapper = null;
        _this.playerControlsWrapper = null;
        _this.hls = null;
        _this.video = null;
        _this.recoverDecodingErrorDate = null;
        _this.recoverSwapAudioCodecDate = null;
        _this.sendEventLock = true;
        _this.sendEventTimeout = null;
        _this.prevEventTime = 0;
        _this.airPlayNativePlayback = false;
        _this.airPlayDisconnectTimer = null;
        return _this;
    }
    _create_class(PlayerWrapper, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                if (isEqual(nextProps, this.props) && isEqual(nextState, this.state)) {
                    return false;
                }
                return true;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.video.addEventListener("webkitcurrentplaybacktargetiswirelesschanged", this.onAirPlayTargetChanged);
                if (!Hls.isSupported() && this.video.canPlayType("application/vnd.apple.mpegurl")) {
                    this.setState({
                        canSupportNativeHls: true
                    });
                } else {
                    document.addEventListener("fullscreenchange", this.setFullscreen, false);
                    document.addEventListener("mozfullscreenchange", this.setFullscreen, false);
                    document.addEventListener("MSFullscreenChange", this.setFullscreen, false);
                    document.addEventListener("webkitfullscreenchange", this.setFullscreen, false);
                    document.addEventListener("keydown", this.detectTabKey, false);
                }
                if (this.props.videoAfterSubscription.channelId) {
                    this.props.setCurrentVideo(this.props.videoAfterSubscription);
                    this.props.resetVideoToPlayAfterSubscription();
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this_state = this.state, isOpenSettingsList = _this_state.isOpenSettingsList, isOpenShareList = _this_state.isOpenShareList, focusedElement = _this_state.focusedElement, castSession = _this_state.castSession;
                var _this_props = this.props, videoPlayer = _this_props.videoPlayer, header = _this_props.header, isMenuOpened = _this_props.isMenuOpened, routerContainer = _this_props.routerContainer;
                var isFocusChanged = prevState.focusedElement !== focusedElement || document.activeElement !== focusedElement;
                var isFocusOnPlayer = this.videoPlayerWrapper && this.videoPlayerWrapper.contains(document.activeElement) || header && header.contains(document.activeElement);
                var isPlayerOpened = videoPlayer.isOpen;
                var isVideoPaused = videoPlayer.video.paused;
                // Destroying the hls when video was stopped by the user
                // so it is not playing anymore but the hls already exists (video was played before)
                if (!videoPlayer.isPlaying && this.hls !== null) {
                    this.hls.destroy();
                }
                if (prevProps.videoPlayer.video.source !== videoPlayer.video.source && videoPlayer.video.source) {
                    this.video.ontimeupdate = null;
                    if (videoPlayer.channelId) {
                        this.props.getAllEpgsForChannel(videoPlayer.channelId);
                    }
                    this.setState({
                        isVideoLoading: true
                    });
                    this.initPlayer(videoPlayer.video);
                    if (!prevState.isOpenEpgsList) {
                        this.video.focus();
                    }
                }
                if (!videoPlayer.isOpen && prevProps.videoPlayer.isOpen) {
                    this.setState(function() {
                        return {
                            isOpenEpgsList: false,
                            isOpenSettingsList: false,
                            isOpenShareList: false
                        };
                    });
                }
                if (videoPlayer.channelId !== undefined) {
                    if (prevProps.videoPlayer.allEpgs !== videoPlayer.allEpgs || prevProps.videoPlayer.video.source !== videoPlayer.video.source) {
                        this.setEpgs(videoPlayer);
                    }
                    if (!videoPlayer.isOpen && prevProps.videoPlayer.isOpen) {
                        if (!this.state.canSupportNativeHls) {
                            this.showControls();
                        }
                    } else if (videoPlayer.isOpen && !prevProps.videoPlayer.isOpen) {
                        if (!this.state.canSupportNativeHls) {
                            this.video.focus();
                        }
                    }
                    if (videoPlayer.channelId !== prevProps.videoPlayer.channelId) {
                        if (prevProps.screenType.tablet || prevProps.screenType.mobile) {
                            if (videoPlayer.channelId) {
                                prevProps.getAllEpgsForChannel(videoPlayer.channelId);
                            }
                        }
                    }
                }
                if (!videoPlayer.isOpen && prevProps.videoPlayer.isOpen && !this.state.areControlsHidden) {
                    this.setState({
                        areControlsHidden: true
                    });
                }
                if (prevProps.videoPlayer.video.waiting === false && this.state.isVideoLoading) {
                    this.setState({
                        isVideoLoading: false
                    });
                }
                if (this.state.shouldLoadNewVideo) {
                    this.initPlayer(this.props.videoPlayer.video);
                    this.setState({
                        shouldLoadNewVideo: false
                    });
                }
                if (this.state.castSession) {
                    this.video.volume = 0;
                }
                if (isCastAvailable()) {
                    var currentCastSession = cast.framework.CastContext.getInstance().getCurrentSession();
                    if (currentCastSession && !castSession && videoPlayer.epgs) {
                        this.startCastSession();
                        this.showControls();
                    }
                    if (!currentCastSession && castSession) {
                        this.setState({
                            castSession: null
                        });
                    }
                }
                if (isFocusChanged) {
                    if ((isFocusOnPlayer || isOpenSettingsList || isOpenShareList || isMenuOpened) && isPlayerOpened) {
                        isVideoPaused || isMenuOpened ? this.showControls() : this.toggleControls();
                    }
                    if (!isFocusOnPlayer && document.activeElement !== document.body && isPlayerOpened && routerContainer.contains(document.activeElement)) {
                        this.props.closePlayer();
                    } else if (this.video === document.activeElement && !isPlayerOpened) {
                        this.props.openPlayer();
                    }
                    if (document.activeElement !== document.body && document.activeElement !== prevState.focusedElement) {
                        this.setState(function() {
                            return {
                                focusedElement: document.activeElement
                            };
                        });
                    } else if (document.activeElement === document.body && focusedElement !== prevState.focusedElement) {
                        focusedElement.focus();
                    }
                }
                if (diffObjects(prevProps, this.props, [
                    "profileSettings.web_settings.resolution"
                ])) {
                    var videoPlayer1 = this.props.videoPlayer;
                    this.handleInitialVideoLevel(videoPlayer1.video.levels);
                }
                if (diffObjects(prevProps, this.props, [
                    "videoPlayer.video.subtitleTracks",
                    "profileSettings.web_settings.subtitles",
                    "videoPlayer.video.currentSubtitleTrack"
                ])) {
                    var video = this.props.videoPlayer.video;
                    this.switchToDefaultResource(video.subtitleTracks, "subtitles", "subtitleTrack");
                }
                if (diffObjects(prevProps, this.props, [
                    "videoPlayer.video.audioTracks",
                    "profileSettings.web_settings.audio"
                ])) {
                    var video1 = this.props.videoPlayer.video;
                    this.switchToDefaultResource(video1.audioTracks, "audio", "dvbAudioTrack");
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearTimeout(this.controlsTimeout);
                clearTimeout(this.airPlayDisconnectTimer);
                this.airPlayDisconnectTimer = null;
                if (this.video) {
                    this.video.removeEventListener("webkitcurrentplaybacktargetiswirelesschanged", this.onAirPlayTargetChanged);
                }
                if (this.hls !== null) {
                    this.hls.destroy();
                    this.props.setVideoToPlayAfterSubscription({
                        video: {
                            startPosition: this.getCurrentTime() || -1
                        }
                    });
                    this.props.resetVideo();
                // hls.js is torn down while casting, so the resume position has to be
                // stored from the native-playback branch instead.
                } else if (this.state.canSupportNativeHls || this.airPlayNativePlayback) {
                    this.props.setVideoToPlayAfterSubscription({
                        video: {
                            startPosition: this.getCurrentTime() || -1
                        }
                    });
                    this.props.resetVideo();
                }
                this.video = null;
                document.removeEventListener("fullscreenchange", this.setFullscreen, false);
                document.removeEventListener("mozfullscreenchange", this.setFullscreen, false);
                document.removeEventListener("MSFullscreenChange", this.setFullscreen, false);
                document.removeEventListener("webkitfullscreenchange", this.setFullscreen, false);
                document.removeEventListener("keydown", this.detectTabKey, false);
                this.setState = function(state, callback) {
                    return;
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, videoPlayer = _this_props.videoPlayer, i18n = _this_props.i18n, screenType = _this_props.screenType, logos = _this_props.logos, liveChannels = _this_props.liveChannels, isScreenLandscape = _this_props.isScreenLandscape, isMobileOnLandscape = _this_props.isMobileOnLandscape, closePlayer = _this_props.closePlayer;
                var _this_state = this.state, currentTime = _this_state.currentTime, liveProgress = _this_state.liveProgress, isOpenSettingsList = _this_state.isOpenSettingsList, areControlsHidden = _this_state.areControlsHidden, isOpenShareList = _this_state.isOpenShareList, isOpenEpgsList = _this_state.isOpenEpgsList, isForwardClicked = _this_state.isForwardClicked, isVolumeChangedFromKeyboard = _this_state.isVolumeChangedFromKeyboard, isSoundToggledFromKeyboard = _this_state.isSoundToggledFromKeyboard, isBackwardClicked = _this_state.isBackwardClicked, shouldFocusShareButton = _this_state.shouldFocusShareButton, shouldFocusSettingsButton = _this_state.shouldFocusSettingsButton, isShareListToggledFromKeyboard = _this_state.isShareListToggledFromKeyboard, isSettingsListToggledFromKeyboard = _this_state.isSettingsListToggledFromKeyboard, videoHasFatalError = _this_state.videoHasFatalError, isVideoChanged = _this_state.isVideoChanged, chromeCastPlayer = _this_state.chromeCastPlayer, castSession = _this_state.castSession, chromeCastControls = _this_state.chromeCastControls, canSupportNativeHls = _this_state.canSupportNativeHls;
                var channelLogo = logos && logos[videoPlayer.channelId];
                var isTabletOrWeb = !isMobile.any() && window.innerWidth >= MOBILE_TYPE_PX || isMobile.any() && (window.innerWidth >= LARGE_MOBILE_TYPE_PX || window.innerWidth >= MOBILE_TYPE_PX && !isScreenLandscape);
                var nativeClass = canSupportNativeHls ? " native" : "";
                var isActiveClass = videoPlayer.isOpen ? " active" : "";
                var closedPlayingClass = videoPlayer.isPlaying && !videoPlayer.isOpen && !isMobile.any() ? " playing" : "";
                var openedPlayingClass = videoPlayer.isOpen && !videoPlayer.video.isFullscreen && isTabletOrWeb ? " opened-player" : "";
                var isEpgListOpenClass = isOpenEpgsList ? " active" : "";
                var mobileControlsClass = isMobile.any() ? " mobile" : "";
                var controlsClass = areControlsHidden ? "" : " show-controls";
                var cursorClass = areControlsHidden ? "" : " show-cursor";
                var fullscreenClass = videoPlayer.video.isFullscreen ? " fullscreen" : "";
                var controlsWrapperClasses = "".concat(closedPlayingClass).concat(controlsClass).concat(openedPlayingClass).concat(mobileControlsClass);
                var actions = {
                    play: this.play,
                    pause: this.pause,
                    togglePlay: this.togglePlay,
                    ended: this.ended,
                    forward: this.forward,
                    backward: this.backward,
                    getCurrentTime: this.getCurrentTime,
                    setCurrentTime: this.setCurrentTime,
                    getVolume: this.getVolume,
                    setVolume: this.setVolume,
                    toggleFullscreen: this.toggleFullscreen,
                    changeVideo: this.changeVideo,
                    timeUpdate: this.timeUpdate,
                    getDuration: this.getDuration,
                    progress: this.progress,
                    setVideoToLive: this.setVideoToLive,
                    changeQuality: this.changeQuality,
                    changeAudioTrack: this.changeAudioTrack,
                    changeSubtitleTrack: this.changeSubtitleTrack,
                    toggleSettingsList: this.toggleSettingsList,
                    toggleShareList: this.toggleShareList,
                    setShareTime: this.setShareTime,
                    toggleMute: this.toggleMute,
                    chromecastSeekRequest: this.chromecastSeekRequest
                };
                var videoAdditionalProps = {
                    isForwardClicked: isForwardClicked,
                    isBackwardClicked: isBackwardClicked,
                    isVolumeChangedFromKeyboard: isVolumeChangedFromKeyboard,
                    isSoundToggledFromKeyboard: isSoundToggledFromKeyboard,
                    isVideoChanged: isVideoChanged
                };
                var playerOptionsAdditionalProps = {
                    shouldFocusShareButton: shouldFocusShareButton,
                    isOpenShareList: isOpenShareList,
                    isOpenSettingsList: isOpenSettingsList,
                    shouldFocusSettingsButton: shouldFocusSettingsButton
                };
                var playerControls = videoPlayer.epgs ? /*#__PURE__*/ _jsxs("div", {
                    className: "player-controls-wrapper".concat(controlsWrapperClasses),
                    children: [
                        /*#__PURE__*/ _jsx(ReactTooltip, {
                            disable: !screenType.web,
                            id: "player-tooltip",
                            effect: "solid",
                            delayShow: TOOLTIP_SHOW_DELAY,
                            className: "tooltip",
                            place: "bottom"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "player-controls".concat(isEpgListOpenClass).concat(closedPlayingClass).concat(mobileControlsClass).concat(nativeClass).concat(fullscreenClass),
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "main",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            style: {
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                paddingLeft: videoPlayer.isVod ? 30 : 0
                                            },
                                            children: [
                                                !videoPlayer.isVod && /*#__PURE__*/ _jsx(ChannelLogo, {
                                                    channelLogo: channelLogo,
                                                    hasName: false,
                                                    closePlayer: closePlayer,
                                                    tabIndex: "0",
                                                    isInPlayer: true,
                                                    className: "logo white-logo",
                                                    isCentered: false,
                                                    toggleFullscreen: this.toggleFullscreen
                                                }),
                                                screenType.web || screenType.tablet ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(PlayerControls, {
                                                            videoPlayer: videoPlayer,
                                                            i18n: i18n,
                                                            screenType: screenType,
                                                            actions: actions,
                                                            currentTime: currentTime,
                                                            playbackButtons: /*#__PURE__*/ _jsx(PlaybackButtons, {
                                                                i18n: i18n,
                                                                screenType: screenType,
                                                                videoPlayer: videoPlayer,
                                                                actions: actions
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(PlayerOptions, {
                                                            chromeCastOptions: {
                                                                chromeCastPlayer: chromeCastPlayer,
                                                                chromeCastControls: chromeCastControls,
                                                                castSession: castSession,
                                                                chromecastSeekRequest: this.chromecastSeekRequest
                                                            },
                                                            videoPlayer: videoPlayer,
                                                            actions: actions,
                                                            i18n: i18n,
                                                            screenType: screenType,
                                                            logos: logos,
                                                            liveChannels: liveChannels,
                                                            playerOptionsAdditionalProps: playerOptionsAdditionalProps
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ProgressBar, {
                                            videoPlayer: videoPlayer,
                                            actions: actions,
                                            currentTime: currentTime,
                                            liveProgress: liveProgress
                                        }),
                                        screenType.web || screenType.tablet && !(isMobileOnLandscape && window.innerHeight <= 550) ? /*#__PURE__*/ _jsx(ChannelInfo, {
                                            epgs: videoPlayer.epgs,
                                            i18n: i18n,
                                            isVod: videoPlayer.isVod
                                        }) : null,
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "current-title",
                                            children: videoPlayer.epgs.current.title
                                        })
                                    ]
                                }),
                                !videoPlayer.isVod && /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "open-list",
                                            tabIndex: "0",
                                            "data-tip": !isOpenEpgsList ? i18n.common.program : i18n.common.back,
                                            "data-for": "player-tooltip",
                                            "data-place": "left",
                                            onKeyDown: this.toggleEpgsListFromKeyboard,
                                            onClick: this.toggleEpgsList,
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "icon icon-play"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "epgs-list-wrapper",
                                            children: [
                                                /*#__PURE__*/ _jsx(ReactTooltip, {
                                                    id: "player-slider-tooltip",
                                                    className: "tooltip",
                                                    delayShow: TOOLTIP_SHOW_DELAY,
                                                    disable: !screenType.web,
                                                    place: "bottom",
                                                    effect: "solid"
                                                }),
                                                /*#__PURE__*/ _jsx(ChannelLogo, {
                                                    channelLogo: channelLogo,
                                                    hasName: false,
                                                    isInPlayer: true,
                                                    visible: !videoPlayer.isVod,
                                                    closePlayer: closePlayer,
                                                    tabIndex: "".concat(isOpenEpgsList ? "0" : "-1"),
                                                    className: "logo white-logo",
                                                    isCentered: false,
                                                    toggleFullscreen: this.toggleFullscreen
                                                }),
                                                this.state.isOpenEpgsList && /*#__PURE__*/ _jsx(ShowsSlider, {
                                                    infinite: true,
                                                    isOpenEpgsList: isOpenEpgsList,
                                                    videoPlayerWrapper: this.videoPlayerWrapper,
                                                    tabIndex: isOpenEpgsList ? "0" : "-1",
                                                    shows: videoPlayer.epgs.all,
                                                    category: {
                                                        id: videoPlayer.channelId
                                                    },
                                                    showHasLabel: true,
                                                    isInPlayer: true,
                                                    hasTitle: false,
                                                    i18n: i18n,
                                                    type: videoPlayer.isVod && VOD,
                                                    closePlayer: closePlayer,
                                                    hasLogo: false,
                                                    showCategories: true,
                                                    showLiveLabel: true,
                                                    responsiveKey: SLIDER_FOR_PLAYER,
                                                    initialOffset: videoPlayer.epgs.initialOffset,
                                                    initialToIndex: videoPlayer.epgs.initialToIndex,
                                                    currentWatchedEpg: videoPlayer.epgs.current,
                                                    darkerThumbnail: true,
                                                    channelsLogos: logos,
                                                    hideOpenEpgsOnPlay: true,
                                                    hideOpenEpgs: this.toggleEpgsList
                                                }, "all-".concat(videoPlayer.channelId))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : null;
                var settingsListTemplate = videoPlayer.video && /*#__PURE__*/ _jsx(SettingsList, {
                    isOpenSettingsList: isOpenSettingsList,
                    videoPlayer: videoPlayer,
                    logos: logos,
                    actions: actions,
                    i18n: i18n,
                    screenType: screenType
                });
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            ref: function(elem) {
                                return _this.videoPlayerWrapper = elem;
                            },
                            className: "video-player-wrapper".concat(isActiveClass).concat(closedPlayingClass).concat(cursorClass).concat(fullscreenClass),
                            onClick: function(e) {
                                return _this.openPlayer(e);
                            },
                            onKeyDown: this.controlVideoFromKeyboard,
                            onMouseMove: this.toggleControls,
                            onMouseDown: this.showControlsAddFlag,
                            onMouseUp: this.hideControlsWithTimeoutRemoveFlag,
                            onMouseLeave: this.hideControls,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "fatal-error".concat(videoHasFatalError || this.state.isVideoLoading && !canSupportNativeHls ? " active" : ""),
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "spinner-three-bounce",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "bounce-1"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "bounce-2"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "bounce-3"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "video-wrapper".concat(isActiveClass),
                                    children: [
                                        (screenType.tablet || screenType.mobile || isMobileOnLandscape) && !canSupportNativeHls ? /*#__PURE__*/ _jsxs("div", {
                                            className: "responsive-controls".concat(controlsClass).concat(fullscreenClass),
                                            children: [
                                                videoPlayer.epgs && videoPlayer.epgs.all && videoPlayer.epgs.all.length > 0 ? /*#__PURE__*/ _jsxs("div", {
                                                    className: "current-show",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "title",
                                                            children: videoPlayer.epgs.current.title
                                                        }),
                                                        !videoPlayer.isVod && /*#__PURE__*/ _jsx("div", {
                                                            className: "duration",
                                                            dangerouslySetInnerHTML: getDateAndTime(videoPlayer.epgs.current.start, videoPlayer.epgs.current.stop, i18n.months)
                                                        })
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "options-wrapper".concat(!videoPlayer.isOpen ? " closed-player" : ""),
                                                    children: [
                                                        /*#__PURE__*/ _jsx(ChromeCastButton, {}),
                                                        /*#__PURE__*/ _jsx(FullScreenButton, {
                                                            i18n: i18n,
                                                            videoPlayer: videoPlayer,
                                                            actions: actions
                                                        }),
                                                        /*#__PURE__*/ _jsx(MenuButton, {
                                                            videoPlayer: videoPlayer,
                                                            actions: actions
                                                        })
                                                    ]
                                                }),
                                                channelLogo ? /*#__PURE__*/ _jsx(ChannelLogo, {
                                                    channelLogo: channelLogo,
                                                    hasName: false,
                                                    isInPlayer: true,
                                                    className: "logo white-logo"
                                                }) : null,
                                                /*#__PURE__*/ _jsx(PlaybackButtons, {
                                                    i18n: i18n,
                                                    screenType: screenType,
                                                    videoPlayer: videoPlayer,
                                                    actions: actions
                                                })
                                            ]
                                        }) : null,
                                        screenType.web && !canSupportNativeHls && videoPlayer.video ? /*#__PURE__*/ _jsx(SettingsList, {
                                            isOpenSettingsList: isOpenSettingsList,
                                            ref: this.settingsList,
                                            logos: logos,
                                            liveChannels: liveChannels,
                                            isShareListToggledFromKeyboard: isShareListToggledFromKeyboard,
                                            isSettingsListToggledFromKeyboard: isSettingsListToggledFromKeyboard,
                                            isOpenShareList: isOpenShareList,
                                            videoPlayer: videoPlayer,
                                            actions: actions,
                                            i18n: i18n,
                                            screenType: screenType
                                        }) : null,
                                        videoPlayer.video.muted && canSupportNativeHls ? /*#__PURE__*/ _jsx("div", {
                                            className: "unmute-button-wrapper",
                                            onClick: function() {
                                                return _this.toggleMute(false, true);
                                            },
                                            children: /*#__PURE__*/ _jsxs("button", {
                                                className: "button raised",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "icon icon-volume-off"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "label",
                                                        children: "tap to unmute"
                                                    })
                                                ]
                                            })
                                        }) : null,
                                        /*#__PURE__*/ _jsx("div", {
                                            id: "video-no-controls-wrapper",
                                            children: /*#__PURE__*/ _jsx(Video, {
                                                videoPlayer: videoPlayer,
                                                customRef: function(elem) {
                                                    return _this.video = elem;
                                                },
                                                actions: actions,
                                                i18n: i18n,
                                                castSession: castSession,
                                                videoAdditionalProps: videoAdditionalProps,
                                                canSupportNativeHls: canSupportNativeHls
                                            })
                                        }),
                                        videoPlayer.video.isFullscreen && videoPlayer.isPlaying && !canSupportNativeHls ? playerControls : null
                                    ]
                                }),
                                !videoPlayer.video.isFullscreen && videoPlayer.isPlaying ? playerControls : null,
                                (screenType.tablet || screenType.mobile) && !canSupportNativeHls && videoPlayer.video.isFullscreen ? settingsListTemplate : null
                            ]
                        }),
                        (screenType.tablet || screenType.mobile) && !canSupportNativeHls && !videoPlayer.video.isFullscreen ? settingsListTemplate : null
                    ]
                });
            }
        }
    ]);
    return PlayerWrapper;
}(Component);
var mapStateToProps = function(param) {
    var videoPlayer = param.videoPlayer, liveChannels = param.liveChannels, logos = param.logos, i18n = param.i18n, screenType = param.screenType, videoAfterSubscription = param.videoAfterSubscription, focusedElement = param.focusedElement, profileSettings = param.profileSettings;
    return {
        videoPlayer: videoPlayer,
        logos: logos,
        i18n: i18n,
        screenType: screenType,
        liveChannels: liveChannels,
        focusedElement: focusedElement,
        videoAfterSubscription: videoAfterSubscription,
        profileSettings: profileSettings
    };
};
export default connect(mapStateToProps, {
    toggleVideoPlayerState: toggleVideoPlayerState,
    getAllEpgsForChannel: getAllEpgsForChannel,
    setVideoPlayerEpgs: setVideoPlayerEpgs,
    setCurrentVideo: setCurrentVideo,
    setVideoOptions: setVideoOptions,
    toggleHeader: toggleHeader,
    resetVideo: resetVideo,
    setVideoToPlayAfterSubscription: setVideoToPlayAfterSubscription,
    resetVideoToPlayAfterSubscription: resetVideoToPlayAfterSubscription,
    deleteAuthToken: deleteAuthToken,
    removeUserDetails: removeUserDetails,
    setProfileSettings: setProfileSettings,
    openModal: openModal
})(withRouter(PlayerWrapper));
